export default {
  label: '研发总监',
  id: '0',
  children: [
    {
      label: '岗位定义',
      id: '0-1',
      children: [
        {
          label: '专注于新技术的研发和应用',
          id: '0-1-1',
        }
      ]
    },
    {
      label: '岗位职责',
      id: '0-2',
      children: [
        {
          label: '负责公司研发项目的规划和实施',
          id: '0-2-1',
        },
        {
          label: '引导研发团队进行技术创新和产品开发',
          id: '0-2-2',
        },
        {
          label: '管理研发资源，优化研发流程',
          id: '0-2-3',
        },
        {
          label: '推动技术成果的产业化应用',
          id: '0-2-4',
        }
      ]
    },
    {
      label: '技能要求',
      id: '0-3',
      children: [
        {
          label: '具备深厚的技术背景和丰富的研发经验',
          id: '0-3-1',
        },
        {
          label: '具备较强的创新能力和项目管理能力',
          id: '0-3-2',
        },
        {
          label: '熟悉行业发展趋势和技术前沿',
          id: '0-3-3',
        },
        {
          label: '具备较强的沟通能力和团队协作能力',
          id: '0-3-4',
        }
      ]
    }
  ]
}